<template>
  <div class="bookType">
    <ComponentsList ref="componentsList" :props-columns="columns" :props-data="propsData" :search-form="searchForm" @edit="handleBookTypeEdit">
      <div class="right opbnt">
        <el-button
          type="primary"
          size="medium"
          @click="handleAdd"
        >
          添加图书类别
        </el-button>
      </div>
    </ComponentsList>
    <el-dialog
      v-if="handleFormAdd.dialogAddVisible"
      :close-on-click-modal="false"
      :visible.sync="handleFormAdd.dialogAddVisible"
      title="添加类别"
      width="600px"
    >
      <el-form
        ref="handleFormAdd"
        :model="handleFormAdd"
        :rules="handleFormrules"
        label-position="right"
        label-width="110px"
      >
        <el-form-item label="类别名称：" prop="name">
          <el-input
            v-model="handleFormAdd.name "
            name="name "
            maxlength="52"
            placeholder="请输入类别名称"
            class="handle-form-input"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="handleFormAdd.dialogAddVisible = false">
          取消
        </el-button>
        <el-button
          :loading="ajaxLoading"
          type="primary"
          size="medium"
          @click="handleTypeAdd"
        >
          {{ ajaxLoading?'Loading':'确定' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import EllaRentBooks from '@/api/userManagement/ellaRentBooks';
import ComponentsList from '@/views/financialCenter/ellaRentBooks/common/componentsList';
import { columnsBookType } from '@/views/financialCenter/ellaRentBooks/common/columns';

export default {
  name: 'BookType',
  components: { ComponentsList },
  data() {
    return {
      ajaxLoading: false,
      searchForm: {
        pid: '',
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      propsData: {
        tree: true,
        treeApi: 'get_types_tree',
        api: 'get_types_pagelist'
      },
      handleFormAdd: {
        type: 'add',
        dialogAddVisible: false,
        name: ''
      },
      handleFormrules: {
        name: [
          { required: true, message: '类别名称不能为空', trigger: 'blur' },
          { max: 50, min: 1, message: '请输入50以内字符', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    columns() {
      return columnsBookType;
    }
  },
  mounted() {
  },
  methods: {
    // 编辑分类
    async handleBookTypeEdit(val) {
      this.handleFormAdd.dialogAddVisible = true;
      this.handleFormAdd.type = 'edit';
      this.handleFormAdd.id = val;
      try {
        const res = await EllaRentBooks['get_types_detail'](this.handleFormAdd.id);
        this.handleFormAdd.name = res.data.name;
      } catch (error) {
        console.log(error);
      }
    },
    // 添加分类弹窗
    handleAdd() {
      this.handleFormAdd.dialogAddVisible = true;
      this.handleFormAdd.type = 'add';
      this.handleFormAdd.name = '';
    },
    // 添加分类
    handleTypeAdd() {
      const _self = this;
      this.ajaxLoading = true;
      this.$refs.handleFormAdd.validate((valid) => {
        if (valid) {
          if (this.handleFormAdd.type === 'add') {
            const op = { pid: this.$refs.componentsList.searchForm.pid, name: this.handleFormAdd.name };
            EllaRentBooks['get_types_add'](op).then((res) => {
              if (res.code === '0') {
                this.handleFormAdd.dialogAddVisible = false;
                this.$message.success('操作成功');
                this.$store.dispatch('fetchAppBooKtypesTree').then(() => {
                  _self.$refs.componentsList.fetchdataList();
                });
              }
            });
          } else {
            const op = { name: this.handleFormAdd.name };
            EllaRentBooks['get_types_edit'](op, this.handleFormAdd.id).then((res) => {
              if (res.code === '0') {
                this.handleFormAdd.dialogAddVisible = false;
                this.$message.success('操作成功');
                this.$store.dispatch('fetchAppBooKtypesTree').then(() => {
                  _self.$refs.componentsList.fetchdataList();
                });
              }
            });
          }
        }
        this.ajaxLoading = false;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.opbnt{    margin-bottom: 20px;}
</style>
